<script setup>
defineProps({
  items: {
    type: Array,
  },
  query: {
    type: String,
  },
  nextStepsTitle: {
    type: String,
  },
  nextStepsBody: {
    type: String,
  },
  productsTitle: {
    type: String,
  },
  catheterCta: {
    type: Object,
  },
  ostomyCta: {
    type: Object,
  },
  baseUrl: {
    type: String,
  },
})
</script>

<template>
  <!-- Product Preview Block -->
  <div class="product-preview w-full ten-col-max mx-auto">
    <h2
      v-if="productsTitle"
      class="relative font-semibold mb-5 text-xl lg:text-2xl lg:mb-8"
    >
      {{ productsTitle }}
    </h2>
    <div class="product-preview__wrap relative">
      <div class="product-preview__list-wrap">
        <div class="product-preview__list">
          <NuxtLink
            v-for="(product, index) in items"
            :key="index"
            :to="useCmsUrl(`${baseUrl}/${product.path}/${product.url}`)"
            class="block"
          >
            <div class="block rounded-xl w-full card-shadow bg-white mb-3 aspect-square 2xl:mb-5">
              <NuxtImg
                provider="fastlyAprimo"
                :src="product.imageUrl || '/images/coming_soon.png'"
                class="rounded-xl w-full aspect-square object-contain"
                :alt="product.imageAltText"
                loading="lazy"
              />
            </div>
            <span
              v-if="product.title?.fragments?.[0]?.internalFormat"
              class="underline font-semibold text-[15px] 2xl:text-lg"
              v-html="product.title.fragments[0].internalFormat"
            />
          </NuxtLink>
        </div>
      </div>
      <div class="product-preview__body prose">
        <h3>{{ nextStepsTitle }}</h3>
        <div
          v-if="nextStepsBody"
          v-html="nextStepsBody"
        />
        <UButton
          :to="`${useCmsUrl(catheterCta?.href)}?searchTerm=${query}`"
          :locale="false"
          color="primary"
          variant="solid"
          :label="catheterCta?.text"
          class="btn w-full mb-3 lg:mb-4 no-underline justify-center"
        />
        <UButton
          :to="`${useCmsUrl(ostomyCta?.href)}?searchTerm=${query}`"
          :locale="false"
          color="primary"
          variant="outline"
          :label="ostomyCta?.text"
          class="btn w-full no-underline justify-center"
        />
      </div>
    </div>
  </div>
</template>

<style lang="scss">
@use '@/assets/css/blocks/product-preview.scss';
</style>
